<template>
    <b-container class="shoplist pt-4">
        <b-row>
            <SidebarCategories :brands="brands" :categories="categories" :variations="variations"/>
            <b-col>
                <div class="d-flex flex-column flex-lg-row justify-content-md-between mb-2 mb-lg-4">
                    <div class="mb-lg-0">
                        <span class="category-name" v-if="title">{{ title }}</span>
                        <span class="category-name" v-if="title && total">/</span>
                        <span class="category-name" v-if="total">{{ total }} resultados</span>
                        <hr class="category-line d-lg-none">
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="d-lg-none">
                            <MobileFilters :brands="brands" :categories="categories" :variations="variations"/>
                        </div>
                        <Sort :currentSort="currentSort" class="ml-auto"/>
                    </div>
                </div>
                <hr class="category-line">
                <div v-if="image" class="mb-4">
                    <img :src="imageUrl(image, 870)" :alt="title" :title="title" class="img-fluid"/>
                </div>
                <ShoplistFilters :brands="brands" :categories="categories" :variations="variations" class="d-none d-lg-block"/>
                <component  v-if="products.length" :is="$wdconfig.modules.product.card_type === 'row'? 'b-col' : 'b-row'" :class="$wdconfig.modules.product.card_type === 'row'? 'mb-3' : 'mx-n2'">
                    <component :is="$wdconfig.modules.product.card_type === 'row'? 'b-row' : 'b-col'" class="mb-3 px-2" v-for="product in products" :key="product.code" v-bind="$wdconfig.modules.product.card_type !== 'row' ? { md: $wdconfig.modules.product.size_in_listing === 'large' ? 6 : 4, cols: 6 } : {}">
                        <Product :product="product" :displayAsList="$wdconfig.modules.product.card_type === 'row'"/>
                    </component>
                </component>
                <b-row v-else>
                    <div class="d-flex flex-column align-items-center w-100 category-no-products">
                        <div>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 width="45.311px" height="45.311px" viewBox="0 0 45.311 45.311"
                                 style="enable-background:new 0 0 45.311 45.311;"
                                 xml:space="preserve">
                                    <g>
                                        <path d="M22.675,0.02c-0.006,0-0.014,0.001-0.02,0.001c-0.007,0-0.013-0.001-0.02-0.001C10.135,0.02,0,10.154,0,22.656
                                            c0,12.5,10.135,22.635,22.635,22.635c0.007,0,0.013,0,0.02,0c0.006,0,0.014,0,0.02,0c12.5,0,22.635-10.135,22.635-22.635
                                            C45.311,10.154,35.176,0.02,22.675,0.02z M22.675,38.811c-0.006,0-0.014-0.001-0.02-0.001c-0.007,0-0.013,0.001-0.02,0.001
                                            c-2.046,0-3.705-1.658-3.705-3.705c0-2.045,1.659-3.703,3.705-3.703c0.007,0,0.013,0,0.02,0c0.006,0,0.014,0,0.02,0
                                            c2.045,0,3.706,1.658,3.706,3.703C26.381,37.152,24.723,38.811,22.675,38.811z M27.988,10.578
                                            c-0.242,3.697-1.932,14.692-1.932,14.692c0,1.854-1.519,3.356-3.373,3.356c-0.01,0-0.02,0-0.029,0c-0.009,0-0.02,0-0.029,0
                                            c-1.853,0-3.372-1.504-3.372-3.356c0,0-1.689-10.995-1.931-14.692C17.202,8.727,18.62,5.29,22.626,5.29
                                            c0.01,0,0.02,0.001,0.029,0.001c0.009,0,0.019-0.001,0.029-0.001C26.689,5.29,28.109,8.727,27.988,10.578z"/>
                                    </g>
                                </svg>
                        </div>
                        <div class="mt-3 category-no-products-text">
                            Nenhum produto encontrado
                        </div>
                    </div>
                </b-row>
                <template v-if="total > limit">
                    <hr class="mt-5">
                    <Pagination
                        :total="total"
                        :perPage="limit"
                        page_query="page"
                        @pagechanged="onPageChange"
                    />
                </template>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import SidebarCategories from "~/components/SidebarCategories";
    import Sort from "~/components/Sort";
    import utils from "~/mixins/utils";
    import Pagination from "~/components/Pagination";
    import Product from "~/components/Product";
    import ShoplistFilters from "~/components/Shoplist-filters";
    import MobileFilters from "~/components/MobileFilters";

    export default {
        components: {MobileFilters, ShoplistFilters, Product, Pagination, Sort, SidebarCategories},
        props: {
            products: {
                type: Array,
                default: () => []
            },
            brands: {
                type: Array,
                default: () => []
            },
            variations: {
                // type: Array,
                default: () => []
            },
            categories: {
                type: Array,
                default: () => []
            },
            total: {
                type: Number,
                default: 0
            },
            limit: {
                default: 12
            },
            title: {
                type: String,
                default: ''
            },
            image: {
                type: String,
                default: ''
            },
            currentSort: {
                type: String,
                default: ''
            }
        },
        mixins: [
            utils
        ],
        methods: {
            onPageChange(page) {
                this.$emit('onPageChange', page)
            }
        }
    }
</script>
